export enum LocalStorageKeys {
  ONBOARD = 'onboard',
  LOGIN_ATTEMPTS = 'login-attempts',
  USER = 'lnr-user',
  USERNAME = 'lnr-username',
  FIRST_NAME = 'lnr-first-name',
  PROFILE_PHOTO = 'lnr-profile-photo',
  BANNER = 'banner-notification',
  NOTIFIED_ON_LOGIN = 'notified-on-login',
}
